import { Grid2 } from "@mui/material";
import style from "./SelectPlan.module.scss";
import { ReactComponent as Launchpad } from "../../../../AdminAssets/svg/LaunchPad.svg";
import PageLoading from "../../../../../../GlobalComponents/PageLoading/PageLoading";

export default function SelectPlan({ onSelect, plansInfo, country, loading }) {
  const getPlan = (data) => {
    return data?.find(
      (p) => p.licenseType === "LaunchPad" && p.isSingleSitePlan === true,
    );
  };

  const kubernetesPlan = getPlan(plansInfo?.plans?.licenses);
  const dedicatedPlan = getPlan(plansInfo?.plans?.dedicatedPlans);

  const getMonthlyPrice = (plan) => {
    if (!plan) return "-";
    const monthly = plan.pricing?.find((p) => p.billingType === "Monthly");

    return country === "India"
      ? `${monthly?.orginalPrice_INR}/mo`
      : `${monthly?.originalprice}/mo`;
  };

  const getYearlyPrice = (plan) => {
    if (!plan) return "-";
    const yearly = plan.pricing?.find((p) => p.billingType === "Yearly");

    const price =
      country === "India" ? yearly?.orginalPrice_INR : yearly?.originalprice;

    return price ? `${(price / 12).toFixed(2)}` : "-";
  };

  const plans = [
    {
      id: 1,
      title: "Kubernetes Hosting",
      description:
        "Running and managing containerized applications efficiently",
      planName: kubernetesPlan?.licenseType,
      planCost: getMonthlyPrice(kubernetesPlan),
      save: "Save 85%",
      planPrice: getYearlyPrice(kubernetesPlan),
      points: [
        "Auto-Scaling",
        "Better CI/CD Integration",
        "Cost-Efficient",
        "Distributed",
        "Self-Healing",
      ],
    },
    {
      id: 2,
      title: "Dedicated Hosting",
      description:
        "Having an entire physical server exclusively for your own website",
      planName: dedicatedPlan?.licenseType,
      planCost: getMonthlyPrice(dedicatedPlan),
      save: "Save 70%",
      planPrice: getYearlyPrice(dedicatedPlan),
      points: [
        "Fixed Resources",
        "Manual Maintenance",
        "Single Server Dependency",
        "Less Flexible Deployments",
        "Higher Cost if Underutilized",
      ],
    },
  ];

  return (
    <>
      {loading ? (
        <Grid2 className={style.selectPlanMainContainer}>
          <Grid2 className={style.header}>Select Plan</Grid2>
          <Grid2 className={style.selectPlanContainer}>
            <Grid2 className={style.planOptions}>
              {plans.map((plan) => (
                <Grid2
                  key={plan.id}
                  className={style.planOptionGrid}
                  onClick={() => onSelect(plan.title)}
                >
                  <Grid2 className={style.planInfoHeader}>
                    <Grid2 className={style.title}>{plan.title}</Grid2>
                    <Grid2 className={style.description}>
                      {plan.description}
                    </Grid2>
                  </Grid2>

                  <Grid2 className={style.lineDisplayFlex}>
                    <hr className={style.line} />
                    <Grid2 className={style.startWithColor}>Start with</Grid2>
                    <hr className={style.line} />
                  </Grid2>

                  <Grid2 className={style.planIconDisplayFlex}>
                    <Grid2>
                      <Grid2 className={style.title}>{plan.planName}</Grid2>
                      <Grid2 className={style.displayFlex}>
                        <Grid2 className={style.planCost}>
                          {plan.planCost}
                        </Grid2>
                        <Grid2 className={style.save}>{plan.save}</Grid2>
                      </Grid2>
                      <Grid2 className={style.planPriceDisplayFlex}>
                        <Grid2 className={style.planPrice}>
                          {plan.planPrice}
                        </Grid2>
                        <Grid2 className={style.monFont}>/mon</Grid2>
                      </Grid2>
                    </Grid2>
                    <Launchpad />
                  </Grid2>

                  <Grid2 className={style.line100} />

                  <ul className={style.pointsList}>
                    {plan.points.map((point, index) => (
                      <li key={index} className={style.pointWeight}>
                        {point}
                      </li>
                    ))}
                  </ul>
                </Grid2>
              ))}
            </Grid2>
          </Grid2>
        </Grid2>
      ) : (
        <PageLoading />
      )}
    </>
  );
}
